// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

export const devAuthConfig = {
  domain: "login-staging.recidiviz.org",
  clientId: "jm4ie6E8RhKKWE6Wlu4by16VR7waem3b",
  audience: "https://api-dev.recidiviz.org",
};

export const productionAuthConfig = {
  domain: "login.recidiviz.org",
  clientId: "TRMMU3H5QfcIuTLe7ow5tG29Df7Qj3FH",
  audience: "https://api.recidiviz.org",
};

export const demoAuthConfig = {
  domain: "login-staging.recidiviz.org",
  clientId: "J0W0mafphVc1ec439SiZiWBYAETrLgM5",
  audience: "https://api-dev.recidiviz.org",
};
